// extracted by mini-css-extract-plugin
export default {"container":"PopUpModal_container__1HCBr","closeModalIcon":"PopUpModal_closeModalIcon__pXkVW"};